<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import Button from '../button/Button.vue';
import { callStatus, callUrl } from 'dashboard/api/internalCalls';
import { internalCall } from 'dashboard/lib/internalCallSession';

const props = defineProps({ room: { type: Object, required: true } });
const { t } = useI18n();
const { accountId } = useAccount();
const enabled = ref(false);
const state = internalCall.state;
watch(
  () => [accountId.value, props.room.id],
  async ([account, room]) => {
    enabled.value = false;
    try {
      const result = await callStatus(callUrl(account, room));
      if (account === accountId.value && room === props.room.id)
        enabled.value = Boolean(result.enabled && result.permissions?.join);
    } catch {
      /* Disabled or unauthorized calls do not disrupt text. */
    }
  },
  { immediate: true }
);
</script>

<template>
  <div v-show="enabled" class="flex items-center gap-2">
    <Button
      v-if="
        state.transferRequired &&
        state.roomId === room.id &&
        String(state.accountId) === String(accountId)
      "
      :label="
        t(
          state.transferring
            ? 'INTERNAL_CALL.TRANSFERRING'
            : 'INTERNAL_CALL.TRANSFER'
        )
      "
      size="sm"
      :disabled="state.phase !== 'idle'"
      @click="internalCall.start(accountId, room, true)"
    />
    <Button
      v-else
      :label="t('INTERNAL_CALL.JOIN')"
      icon="i-lucide-phone"
      size="sm"
      :disabled="state.phase !== 'idle'"
      @click="internalCall.start(accountId, room)"
    />
  </div>
</template>
